var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntersect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 57.33 57.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.66,28.21c-1.45,0-2.63-1.18-2.63-2.63s1.18-2.63,2.63-2.63,2.63,1.18,2.63,2.63-1.18,2.63-2.63,2.63m0-7.89c-2.9,0-5.26,2.35-5.26,5.26s2.35,5.26,5.26,5.26,5.26-2.35,5.26-5.26-2.35-5.26-5.26-5.26",
    style: {
      fill: "#c42032"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.03,34.58l-8.37,8.36-8.36-8.36c-4.62-4.62-4.62-12.11,0-16.73,4.62-4.62,12.11-4.62,16.73,0,4.62,4.62,4.62,12.11,0,16.72M28.67,0C12.83,0,0,12.83,0,28.67s12.83,28.66,28.67,28.66c15.82-.02,28.65-12.84,28.66-28.66C57.33,12.83,44.5,0,28.67,0",
    style: {
      fill: "#c42032"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntersect);
export default __webpack_public_path__ + "static/media/Intersect.c165b6418433cf3793e5185ffcc065d1.svg";
export { ForwardRef as ReactComponent };